export default "__VITE_PUBLIC_ASSET__917a4c69__"